import React from "react"
import { Flex, Image, Text } from "@chakra-ui/react"
import cartIcon from "../../../img/cart-icon.svg"
import { COLORS } from "../../../constants/constants"

const CartButton = ({ count = 0, onClick }) => (
  <Flex
    position="relative"
    cursor="pointer"
    onClick={onClick}
    onMouseDown={(e) => {
      e.preventDefault()
    }}
    alignItems={"center"}
    borderRadius="11px"
    bg={COLORS.red}
    p="6px"
    boxShadow="0px 2px 8px rgba(20, 23, 37, 0.08)"
    width={10}
    height={10}
  >
    <Flex>
      <Image src={cartIcon} width={"28px"} height={"28px"} alt="Cart" />
    </Flex>

    {count > 0 && (
      <Flex
        position="absolute"
        top="-10px"
        right="-10px"
        bg={COLORS.black300}
        borderRadius="full"
        width="20px"
        height="20px"
        alignItems="center"
        justifyContent="center"
        zIndex="1"
        border="2px solid #FFFFFF"
      >
        <Text
          color={COLORS.white}
          lineHeight={"11px"}
          fontSize={"10px"}
          fontWeight={700}
        >
          {count}
        </Text>
      </Flex>
    )}
  </Flex>
)

export default CartButton
